<app-modal [isOpen]="modalOpen" (close)="hide()">
    <p class="content">
        <strong>
            {{ text }}
        </strong>
    </p>
    <button (click)="doAction()" class="btn" [attr.aria-label]="buttonText | translate"
            translate>{{ buttonText }}</button>
</app-modal>
